import React, { type ReactElement } from 'react';

import { useEnvironment } from '~/src/contexts/environment';
import { PWSquareLogo } from './PWLogo.square';
import { OmoSquareLogo } from './OmoLogo.square';
import { WSSquareLogo } from './WSLogo.square';
import { OmoFullLogo } from './OmoLogo.horizontal';
import { PWFullLogo } from './PWLogo.horizontal';
import { WSFullLogo } from './WSLogo.horizontal';

type LogoProps = {
  format: 'square' | 'horizontal';
};

export function ProductLogo({ format }: LogoProps): ReactElement {
  const { productName } = useEnvironment();

  switch (productName) {
    case 'OMO':
      return format === 'square' ? <OmoSquareLogo width={80} height={80} /> : <OmoFullLogo />;
    case 'Вейвсенд':
      return format === 'square' ? <WSSquareLogo width={80} height={80} /> : <WSFullLogo />;
    default:
      return format === 'square' ? <PWSquareLogo width={80} height={80} /> : <PWFullLogo />;
  }
}
